import { configureScope } from '@sentry/browser';
import store from '../store';
import {
  saveAccessToken, saveRefreshToken, clearToken, getRefreshToken,
} from '@/utils/jwt';

export default {
  methods: {
    handleUnauthenticated() {
      this.$bus.$emit('unauthenticated');
      store.emptyState();
      this.setUserToDebugger();
      clearToken(); // Clear access-token & refreshToken in localStorage
      getRefreshToken() && this.$mutate( // Revoke refresh-token
        this.$mutations.revokeRefreshToken, { refreshToken: getRefreshToken() },
      );
    },

    handleAuthenticated(user) {
      this.$bus.$emit('authenticated');
      store.setState(user);
      this.setUserToDebugger(user);
    },

    setUserToDebugger(user = {}) {
      configureScope((scope) => {
        scope.setUser({
          username: user && (user.fullName || 'guest'),
          id: user && user.id,
        });
      });
    },

    async logout() {
      this.handleUnauthenticated();
      this.$mutate(this.$mutations.logout);
    },

    async login(username, password) {
      store.state.isLoggedIn = false;
      const response = await this.$mutate(
        this.$mutations.obtainJwt,
        { username, password },
        null,
        true,
      );
      const { data, errors } = response;
      const { obtainJwt } = data;

      if (obtainJwt && obtainJwt.token) {
        saveAccessToken(obtainJwt.token);
        saveRefreshToken(obtainJwt.refreshToken, obtainJwt.refreshExpiresIn);
        this.handleAuthenticated(obtainJwt.user);
        const nextParam = this.$route.params.next;
        const redirectToNextRoute = nextParam && !nextParam.includes(this.$route.path);
        const nextRoute = redirectToNextRoute ? this.$route.params.next : '/';

        this.$router.push(nextRoute);
      } else {
        this.handleErrors(errors);
        this.handleUnauthenticated();
      }

      return obtainJwt;
    },

    async setState() {
      const { data } = await this.$query(this.$queries.appState);

      if (data && data.currentUser) {
        this.handleAuthenticated(data.currentUser);
      } else {
        this.handleUnauthenticated();
      }

      this.$bus.$emit('loaded-state');
    },
  },
};
